export default __webpack_public_path__ + "static/media/room-of-requirement.5a6c1787.jpg";